import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from '../services/storages.service';
import { SESSION_ACCESS_KEY, SESSION_LEGACY_KEY, REFRESH_API_PATH, REFRESH_ORBIT_API_PATH } from '@core/constants/token-storage.constants';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  private readonly storageService = inject(StorageService);

  private readonly excludedUrls = [
    'https://qa4.sicopweb.com/api/omnicanal/conversaciones',
    '/assets/',
    '/automapeomdm-dev/',
    'https://qa2.sicopweb.com/',
    'https://qa3.sicopweb.com/',
    'https://api.sicopweb.com/funnel/dev',
    'https://qa1.sicopweb.com/SeekopBusinessAPI/Mty',
    'SeekopBusinessAPI/Mty',
    'https://www.sicopweb.com/Api/Multicanal/Whatsapp/',
    'https://www.sicopweb.com/Api/Multicanal/Meta/',
    'https://www.sicopweb.com/SeekopAPI/ReportesWeb',
    'https://www.sicopweb.com/SeekopAPI/Estrategias',
    'https://www.sicopweb.com/SeekopAPI/adbdc',
    'https://qa.sicopweb.com/Api/Bot',
    'https://qa.sicopweb.com/SeekopAPI/ReportesWeb',
    'https://qa2.sicopweb.com/SeekopAPI/Estrategias',
    'https://qa2.sicopweb.com/SeekopAPI/adbdc',
    'https://seekop10.sicopweb.net/api/10.0.0/ia/plantilla/',
    'https://seekop10.sicopweb.net/api/10.0.0/global/catalogos/empresa/',
    'https://seekop10.sicopweb.net/api/10.0.0/documentos',
    'https://seekop10.sicopweb.net/api/10.0.0/promocionia/',
    'https://seekop10.sicopweb.net/api/10.0.0/ventas/catalogos/nuevos/',
    'https://seekop10.sicopweb.net/api/10.0.0/bitacora',
    'https://www.sicopweb.com/seekopia/1.0/process/MapearExcel',
    'https://api.sicopweb.com/auth/v3/token',
    'https://qa.sicopweb.com/auth/10.0.0/login',
    REFRESH_API_PATH,
    REFRESH_ORBIT_API_PATH,
  ];

  private isExcludedRequest(url: string): boolean {
    return this.excludedUrls.some(excluded => url.includes(excluded));
  }

  private getToken(): string | null {
    const rawAccess = this.storageService.getSessionStorage(SESSION_ACCESS_KEY);
    const rawLegacy = this.storageService.getSessionStorage(SESSION_LEGACY_KEY);
    return (typeof rawAccess === 'string' && rawAccess ? rawAccess : null)
        || (typeof rawLegacy === 'string' && rawLegacy ? rawLegacy : null)
        || this.storageService.getCookie('token')
        || this.storageService.getLocalStorage('token');
  }

  private handleRequestWithToken(request: HttpRequest<unknown>, next: HttpHandler, token: string): Observable<HttpEvent<unknown>> {
    const clonedRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
    return next.handle(clonedRequest);
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.isExcludedRequest(request.url)) {
      return next.handle(request);
    }

    if (request.headers.has('Authorization')) {
      return next.handle(request);
    }

    const token = this.getToken();

    if (token) {
      return this.handleRequestWithToken(request, next, token);
    }

    return next.handle(request);
  }
}